import {restfulClient, actionClient} from "@/api";
import {cloneDeep} from "lodash";
import {formatParams} from "@/helpers";

const signActivityUrl = '/activity/sign/activities'
const prizeOptionUrl = '/user-dispatch-prize/options'
const signRecordUrl = '/activity/sign/records'

const shareActivityUrl = '/activity/share/activities'
const shareRecordUrl = '/activity/share/records'
const shareChartUrl = '/activity/share/chart/'
const shareDetailRecordUrl = '/activity/share/user-records/'

const inviteActivityUrl = '/activity/invite/activities'
const inviteRecordUrl = '/activity/invite/records'
const signChartUrl = '/activity/sign/chart/'
const inviteChartUrl = '/activity/invite/chart/'
const registerActivityUrl = '/activity/register/activities'
const signDetailRecordUrl = '/activity/sign/user-records/'
const inviteDetailRecordUrl = '/activity/invite/user-records/'
const registerRecordUrl = '/activity/register/records'
const registerChartUrl = '/activity/register/chart/'
const luckyTurntableUrl = '/activity/draw/activities'
const luckyChartUrl = '/activity/draw/chart/'
const luckyRecordUrl = '/activity/draw/records/'
const luckyDetailRecordUrl = '/activity/draw/user-records/'

export function getLuckyTurnList(searchForm) {
    return restfulClient.getCollection(luckyTurntableUrl, formatParams(searchForm))
}

export function createLuckyActivity(params) {
    return restfulClient.create(luckyTurntableUrl, params)
}

export function updateLuckyActivity(params) {
    const id = params.id
    // delete params.id
    return restfulClient.put(luckyTurntableUrl, id, params)
}

export function luckDocument(id) {
    return restfulClient.getDocument(luckyTurntableUrl, id, ['rules'])
}

export function luckChart(id) {
    return actionClient.get(luckyChartUrl + id,)
}

export function luckRecord(searchForm) {
    const id = searchForm.id
    return actionClient.get(luckyRecordUrl + id, {query: formatSearchParams(searchForm)})
}

export function luckyDetailRecord(id, user_id) {
    return actionClient.get(luckyDetailRecordUrl + id, {
        query: {userId: user_id},
    })
}

export function delLuckActivity(id) {
    return restfulClient.remove(luckyTurntableUrl, id)
}

export function getSignList(searchForm) {
    let queryParams = cloneDeep(searchForm)
    if (searchForm.query.title) {
        queryParams.query.title = `%${searchForm.query.title}%`
    }
    return restfulClient.getCollection(signActivityUrl, queryParams)
}

export function getPrizeOption(params) {
    return restfulClient.getCollection(prizeOptionUrl, {query: params})
}

export function createSignActivity(params) {
    return restfulClient.create(signActivityUrl, params)
}

export function updateSignActivity(params) {
    const id = params.id
    // delete params.id
    return restfulClient.put(signActivityUrl, id, params)
}

export function delSignActivity(id) {
    return restfulClient.remove(signActivityUrl, id)
}

export function signDocument(id) {
    return restfulClient.getDocument(signActivityUrl, id, ['rules'])
}

export function signRecords(searchForm) {
    const id = searchForm.id
    return actionClient.get(signRecordUrl + '/' + id, {query: formatSearchParams(searchForm)})
}

export function signChart(searchForm) {
    return actionClient.get(signChartUrl + searchForm.id)
}

export function getInviteList(searchForm) {
    let queryParams = cloneDeep(searchForm)
    if (searchForm.query.title) {
        queryParams.query.title = `%${searchForm.query.title}%`
    }
    return restfulClient.getCollection(inviteActivityUrl, queryParams)
}

export function getShareList(searchForm) {
    let queryParams = cloneDeep(searchForm)
    if (searchForm.query.title) {
        queryParams.query.title = `%${searchForm.query.title}%`
    }
    return restfulClient.getCollection(shareActivityUrl, queryParams)
}

export function shareDocument(id) {
    return restfulClient.getDocument(shareActivityUrl, id, ['rules'])
}

export function createShareActivity(params) {
    return restfulClient.create(shareActivityUrl, params)
}

export function updateShareActivity(params) {
    const id = params.id
    // delete params.id
    return restfulClient.update(shareActivityUrl, id, params)
}

export function delShareActivity(id) {
    return restfulClient.remove(shareActivityUrl, id)
}

export function shareRecords(searchForm) {
    let queryParams = cloneDeep(searchForm)
    const id = searchForm.id
    delete queryParams.id
    if (searchForm.field === 'nickName') {
        queryParams.nickName = searchForm.content
    }
    if (searchForm.field === 'phoneNumber') {
        queryParams.phoneNumber = searchForm.content
    }
    return actionClient.get(shareRecordUrl + '/' + id, {query: queryParams})
}

export function shareChart(searchForm) {
    return actionClient.get(shareChartUrl + searchForm.id)
}

export function shareDetailRecord(id, user_id) {
    return actionClient.get(shareDetailRecordUrl + id, {
        query: {userId: user_id}
    })
}


export function inviteDocument(id) {
    return restfulClient.getDocument(inviteActivityUrl, id, ['rules'])
}

export function createInviteActivity(params) {
    return restfulClient.create(inviteActivityUrl, params)
}

export function updateInviteActivity(params) {
    const id = params.id
    // delete params.id
    return restfulClient.put(inviteActivityUrl, id, params)
}

export function delInviteActivity(id) {
    return restfulClient.remove(inviteActivityUrl, id)
}

export function inviteRecords(searchForm) {
    const id = searchForm.id
    return actionClient.get(inviteRecordUrl + '/' + id, {query: formatSearchParams(searchForm)})
}

export function inviteChart(searchForm) {
    return actionClient.get(inviteChartUrl + searchForm.id)
}

export function getRegisterList(searchForm) {
    let queryParams = cloneDeep(searchForm)
    if (searchForm.query.title) {
        queryParams.query.title = `%${searchForm.query.title}%`
    }
    return restfulClient.getCollection(registerActivityUrl, queryParams)
}

export function createRegisterActivity(params) {
    return restfulClient.create(registerActivityUrl, params)
}

export function delRegisterActivity(id) {
    return restfulClient.remove(registerActivityUrl, id)
}

export function registerDocument(id) {
    return restfulClient.getDocument(registerActivityUrl, id, ['rules'])
}

export function updateRegisterActivity(params) {
    const id = params.id
    // delete params.id
    return restfulClient.put(registerActivityUrl, id, params)
}

export function registerRecords(searchForm) {
    const id = searchForm.id
    return actionClient.get(registerRecordUrl + '/' + id, {query: formatSearchParams(searchForm)})
}

export function registerChart(searchForm) {
    return actionClient.get(registerChartUrl + searchForm.id)
}

export function signDetailRecord(id, user_id, page = 1) {
    return actionClient.get(signDetailRecordUrl + id, {
        query: {
            userId: user_id,
            page
        },
    })
}

export function inviteDetailRecord(id, user_id, page = 1) {
    return actionClient.get(inviteDetailRecordUrl + id, {
        query: {
            inviterId: user_id,
            page
        },
    })
}


function formatSearchParams(searchForm) {
    let queryParams = cloneDeep(searchForm)

    delete queryParams.id
    if (searchForm.field === 'nickName') {
        queryParams.nickName = searchForm.content
    }
    if (searchForm.field === 'phoneNumber') {
        queryParams.phoneNumber = searchForm.content
    }
    return queryParams
}
